import { HttpEventType } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap';

import { CBMError, Task } from 'app/models';
import { MstService, TaskService } from 'app/services';

@Component({
  selector: 'app-dialog-import-mst',
  templateUrl: './dialogimportmst.component.html',
  styleUrls: ['./dialogimportmst.component.scss']
})
export class DialogImportMstComponent implements OnInit {
  @ViewChild('importMstDialog') importMstDialog: ModalDirective;
  @ViewChild('mstFileInput') fileInput: ElementRef;

  @Input() contractid: number;

  @Output() onConfirm = new EventEmitter<boolean>();
  @Output() onCancel = new EventEmitter<boolean>();

  public importButtonText: string;
  public runningImport: boolean;
  public isFileSelected: boolean;
  public resultText: string;
  public task: Task;
  public isUploading: boolean;
  public percentDone: number;
  public errorMessage: string;
  public errorCodes: CBMError[];

  constructor(
    private readonly mstService: MstService,
    private readonly taskService: TaskService,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.getResults();
    this.isUploading = false;
    this.initImportButton();
  }

  private initImportButton(): void {
    this.isFileSelected = false;

    this.translateService.get('LOCATIONS.CHOOSEFILE').subscribe(translation => {
      this.importButtonText = translation;
    });
  }

  public show(): void {
    this.importMstDialog.show();
    this.getResults();
  }

  public confirm(): void {
    this.importMstDialog.hide();
    this.onConfirm.emit(true);
  }

  public cancel(): void {
    this.importMstDialog.hide();
    this.onCancel.emit(false);
  }

  public fileChanged(e) {
    this.importButtonText = e.target.value.split('\\').pop();
    this.isFileSelected = true;
  }

  public getResults(): void {
    this.mstService.getImportTask(this.contractid).subscribe(
      result => {
        if (result.status === 'running') {
          this.runningImport = true;
        } else {
          this.initImportButton();
          this.runningImport = false;
        }
        this.resultText = result.remark;
        this.task = result;
      },
      (errors: CBMError[]) => {
        this.errorMessage = errors[0].description;
      }
    );
  }

  private getTask(taskId: number): void {
    this.taskService.getTask(taskId).subscribe(
      result => {
        if (result.status === 'created' || result.status === 'running') {
          this.runningImport = true;
        } else {
          this.initImportButton();
          this.runningImport = false;
        }
        this.resultText = result.remark;
        this.task = result;
      },
      (errors: any) => {
        this.errorMessage = errors[0].description;
      }
    );
  }

  public uploadMST() {
    this.isUploading = true;
    this.errorMessage = null;
    this.errorCodes = [];
    let mstFile: File;

    const inputEl: HTMLInputElement = this.fileInput.nativeElement;
    if (inputEl.files.length > 0) {
      mstFile = inputEl.files.item(0);

      this.mstService.importMst(this.contractid, mstFile).subscribe(
        result => {
          if (result.type === HttpEventType.UploadProgress) {
            // Compute and show the % done:
            this.percentDone = Math.round((100 * result.loaded) / result.total);
          } else if (result.type === HttpEventType.Response) {
            this.getTask(result.body);
            this.isUploading = false;
          }
        },
        (errors: CBMError[]) => {
          if (errors[0].description) {
            this.errorMessage = errors[0].description;
          } else {
            this.errorCodes = errors;
          }
          this.isUploading = false;
        }
      );
    } else {
      this.errorMessage = 'No file selected';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-import-mst/dialogimportmst.component.ts